import Http from "./http";

export const getAll = () => {
  return Http.get('/auth/all');
}
